<script setup>

import useSessionActions from '~/composables/sessions/useSessionActions';
import { slugify } from '~/utilities/slugify';

const props = defineProps({
    session: {
        type: Object,
        required: true,
    },
    doubleBookedSession: {
        type: Object,
        default: null,
    },
});

const emit = defineEmits(['close']);

const { isSaveSeatLoading } = useSessionActions(props.session);

const closeModal = () => {
    emit('close');
};
</script>

<template>
    <div>
        <h2>Oops! Looks like you're trying to double book!</h2>
        <div v-if="doubleBookedSession" class="modal-alert">
            <MessSvg class="warning-icon" type="warning" />
            <p class="fs-16">
                We can't save a seat for "{{ session.title }}" because you have already saved a seat for "{{
                    doubleBookedSession.title
                }}" happening at the same time.
            </p>
        </div>
        <div v-else class="modal-alert">
            <MessSvg class="warning-icon" type="warning" />
            <p class="fs-16">
                We can't save a seat for "{{ session.title }}" because you have already saved a seat for another session
                happening
                at the same time.
            </p>
        </div>
        <div v-if="doubleBookedSession" class="modal-copy">
            <p class="fs-16">
                Please remove your saved seat for
                <MessLink :href="`/agenda/${slugify(doubleBookedSession.title)}`" class="fs-17 underline-link" label="You have double-booked a session.">"{{
                    doubleBookedSession.title }}"</MessLink>
                first by clicking the seat icon on the session card.
            </p>
        </div>
        <div class="modal-action-buttons">
            <ProjectButtonSecondary type="submit" :disabled="isSaveSeatLoading" :loading="isSaveSeatLoading"
                @click="closeModal" :filledIn="true">Close</ProjectButtonSecondary>
        </div>
    </div>
</template>
